import { useState } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import http from 'hub-http/clients/apiClient';
import { TableHoverContent } from 'foundations-components/transitional/components/Table';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { ExpandIcon } from 'foundations-assets/icons/components/ExpandIcon';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { PropertyValueCitation } from 'property-value-citations/public/PropertyValueCitation';
import { ArtificialIntelligenceIcon } from 'foundations-assets/icons/components/ArtificialIntelligenceIcon';
import { StyledTableCell } from '../../table/StyledTableCell';
import MilestoneTitleHoverButton from '../styledComponents/MilestoneTitleHoverButton';
import { InlineEditInput } from '../InlineEditInput';
import { ButtonHoverContainer } from '../styledComponents/ButtonHoverContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function MilestoneStatusCheckbox({
  milestone,
  onUpdateStatus,
  readOnly
}) {
  const isChecked = milestone.status === 'completed';
  const handleChecked = ({
    target: {
      checked
    }
  }) => {
    const newStatus = checked ? 'completed' : 'not_started';
    onUpdateStatus(milestone, newStatus);
  };
  return /*#__PURE__*/_jsx(Checkbox, {
    "aria-label": `check-milestone-${milestone.milestoneId}`,
    checked: isChecked,
    onChange: handleChecked,
    size: "sm",
    marginBlockStart: "100",
    disabled: readOnly
  });
}
export function MilestoneTitleContent({
  milestone,
  onUpdateTitle,
  onToggleMilestoneSidebar,
  suggestion,
  readOnly
}) {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const isChecked = milestone.status === 'completed';
  const hasPendingCompletionSuggestion = suggestion && (suggestion === null || suggestion === void 0 ? void 0 : suggestion.propertyName) === 'hs_status' && (suggestion === null || suggestion === void 0 ? void 0 : suggestion.suggestedValue) === 'completed';
  const showStrikethrough = isChecked || hasPendingCompletionSuggestion;
  const handleTitleSubmit = newTitle => {
    if (newTitle !== milestone.title) {
      onUpdateTitle(milestone, newTitle);
    }
    setIsEditingTitle(false);
  };
  if (isEditingTitle) {
    return /*#__PURE__*/_jsx(InlineEditInput, {
      value: milestone.title,
      typography: "body-100",
      onSubmit: handleTitleSubmit,
      onAutoSave: newTitle => {
        if (newTitle !== milestone.title) {
          onUpdateTitle(milestone, newTitle);
        }
      },
      onCancel: () => setIsEditingTitle(false),
      placeholder: I18n.text('dealPlan.milestones.inputPlaceholder'),
      dataTestId: `milestone-title-input-${milestone.milestoneId}`
    });
  }
  const titleText = /*#__PURE__*/_jsx(Text, Object.assign({
    as: "span",
    typography: "body-100",
    truncate: true
  }, showStrikethrough ? {
    textDecoration: 'line-through',
    color: 'text-core-disabled'
  } : {}, {
    children: milestone.title
  }));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      flex: 1,
      minInlineSize: "0",
      children: [/*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        children: [readOnly ? titleText : /*#__PURE__*/_jsx(MilestoneTitleHoverButton, {
          "data-test-id": `milestone-title-${milestone.milestoneId}`,
          onClick: () => setIsEditingTitle(true),
          onKeyDown: e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setIsEditingTitle(true);
            }
          },
          children: titleText
        }), onToggleMilestoneSidebar && /*#__PURE__*/_jsx(TableHoverContent, {
          children: /*#__PURE__*/_jsx(Flex, {
            alignItems: "center",
            gap: "100",
            children: /*#__PURE__*/_jsx(ButtonHoverContainer, {
              children: /*#__PURE__*/_jsx(IconButton, {
                use: "transparent",
                size: "extra-small",
                onClick: () => onToggleMilestoneSidebar(milestone.milestoneId),
                children: /*#__PURE__*/_jsx(ExpandIcon, {
                  color: "text-core-default"
                })
              })
            })
          })
        })]
      }), hasPendingCompletionSuggestion && /*#__PURE__*/_jsxs(Flex, {
        gap: "100",
        alignItems: "center",
        flexWrap: "wrap",
        children: [/*#__PURE__*/_jsx(Tag, {
          use: "info",
          inline: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "dealPlan.milestones.suggestion.completedMilestoneTag"
          })
        }), /*#__PURE__*/_jsx(PropertyValueCitation, {
          httpClient: http,
          citationType: "smartDataCaptureSuggestionId",
          citationId: suggestion.suggestionId
        })]
      })]
    })
  });
}
export function MilestoneSubjectCell({
  milestone,
  onUpdateTitle,
  onUpdateStatus,
  onToggleMilestoneSidebar,
  suggestion,
  readOnly
}) {
  return /*#__PURE__*/_jsx(StyledTableCell, {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "400",
      children: [suggestion ? /*#__PURE__*/_jsx(ArtificialIntelligenceIcon, {}) : /*#__PURE__*/_jsx(MilestoneStatusCheckbox, {
        milestone: milestone,
        onUpdateStatus: onUpdateStatus,
        readOnly: readOnly
      }), /*#__PURE__*/_jsx(MilestoneTitleContent, {
        milestone: milestone,
        onUpdateTitle: onUpdateTitle,
        onToggleMilestoneSidebar: onToggleMilestoneSidebar,
        suggestion: suggestion,
        readOnly: readOnly
      })]
    })
  });
}